import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField} from '@mui/material';
import {ContactUsStatus, IContactUsRequest, IUpdateContactUsRequest} from '../../core/interfaces';
import {updateContactUsRequest} from '../../services/contact-us';

interface Props {
    request: IContactUsRequest
    onClose: () => void
    onSaved: () => void
}

const STATUS_LABELS: Record<ContactUsStatus, string> = {
    NOT_CONTACTED: 'Not Contacted',
    IN_PROGRESS: 'In Progress',
    CONTACTED: 'Contacted',
    SOLVED: 'Solved',
}

export const ContactUsActionModal: React.FC<Props> = ({request, onClose, onSaved}) => {
    const [status, setStatus] = useState<ContactUsStatus>(request.contactedStatus)
    const [notes, setNotes] = useState<string>(request.notes ?? '')
    const [loading, setLoading] = useState<boolean>(false)

    const handleSave = async () => {
        try {
            setLoading(true)
            const payload: IUpdateContactUsRequest = {contactedStatus: status, notes}
            await updateContactUsRequest(request.id as string, payload)
            onSaved()
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog open onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                {request.firstName} {request.lastName}
            </DialogTitle>
            <DialogContent dividers>
                <div style={{marginBottom: 16}}>
                    <p style={{margin: '4px 0'}}><strong>Email:</strong> {request.email}</p>
                    <p style={{margin: '4px 0'}}><strong>Phone:</strong> {request.phone}</p>
                    <p style={{margin: '4px 0'}}><strong>City:</strong> {request.city}</p>
                    <p style={{margin: '4px 0'}}><strong>Institution:</strong> {request.kindergarten}</p>
                    <p style={{margin: '4px 0'}}><strong>Role:</strong> {request.role}</p>
                    <p style={{margin: '4px 0'}}><strong>Submitted:</strong> {new Date(request.createdAt).toLocaleDateString('ro', {day: '2-digit', month: 'long', year: 'numeric'})}</p>
                </div>
                <FormControl fullWidth style={{marginBottom: 16}}>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={status}
                        label="Status"
                        onChange={(e) => setStatus(e.target.value as ContactUsStatus)}
                    >
                        {(Object.keys(STATUS_LABELS) as ContactUsStatus[]).map(s => (
                            <MenuItem key={s} value={s}>{STATUS_LABELS[s]}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <TextField
                    label="Notes"
                    multiline
                    rows={4}
                    fullWidth
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button variant="contained" onClick={handleSave} disabled={loading}>Save</Button>
            </DialogActions>
        </Dialog>
    )
}
